import PropTypes from 'prop-types';

// @mui material components
import { Box, Card, Grid } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import GroupCard from 'components/Groups/GroupCard';

import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from "@auth0/auth0-react";

// API/MODELS
import groupAPI from "services/api/groups";
import bksAPI from "services/api/bks";

import { processGroupData } from "utils/group";
import { useMatch } from "react-router-dom";
import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";
import { wrapper, loadingScreen } from "utils/wrapper";
import { getUserAccessLevel } from 'utils/setup';

function ClearwayDeviceSubgroupsView({ map, user }) {
  disableMap(map);

  groupAPI.loadToken(useAuth0());
  bksAPI.loadToken(useAuth0());
  const [controller] = useSoftUIController();
  const { deviceLayout } = controller;

  const { group_id } = useMatch('clearways/groups/:group_id/subgroups').params;

  const group = useQuery({
    queryKey: ['getGroupWithID', group_id],
    queryFn: async () => {
      return await groupAPI.getGroupWithID(group_id);
    }
  });

  const devices = useQuery({
    queryKey: ['getAllClearwaysDevices'],
    queryFn: async () => {
      return await bksAPI.getAllClearwaysDevices();
    }
  });

  if (group.isLoading || devices.isLoading) {
    return loadingScreen(deviceLayout, false);
  }

  if (group.error || devices.error) {
    return wrapper("An error has occurred");
  }

  if (!group.data || !devices.data) {
    return loadingScreen(deviceLayout, false);
  }

  var group_data = processGroupData(group.data, devices.data, getUserAccessLevel(user.user.user_type, 'technician'));

  return wrapper((
    <Box p={1}>
      <Card sx={{ minHeight: deviceLayout == 'mobile' ? 'calc(100svh - 5.75rem - 8px)' : 'calc(100svh - 6.5rem - 16px)', height: '100%', backgroundColor: '#eee' }}>
        <SoftBox display="flex" flexDirection="column" p={2}>
          <SoftBox mb={1}>
            <Grid container spacing={1}>
              <Grid item xxs={12}>
                <SoftBox>
                  <SoftTypography pl={1} variant="h4">
                    Subgroups
                  </SoftTypography>
                </SoftBox>
                <SoftBox>
                  <SoftTypography pl={1} variant="body2" color="text">
                    {group_data.name}
                  </SoftTypography>
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
          <Grid container spacing={3}>
            {group_data.subgroups.map((subgroup) => (
              <Grid item xxs={12} md={6} x3l={4} key={subgroup.group_id} onClick={() => { subgroup.group_id }} >
                <GroupCard group={group_data} subgroup={subgroup} user_type={user.user.user_type} />
              </Grid>
            ))}
          </Grid>
        </SoftBox>
      </Card>
    </Box>
  ), deviceLayout, true
  );
}

ClearwayDeviceSubgroupsView.propTypes = {
  map: PropTypes.object,
  navTitle: PropTypes.array,
  setNavTitle: PropTypes.func,
  sidebarState: PropTypes.string,
  setSidebarState: PropTypes.func,
}

export default ClearwayDeviceSubgroupsView;
